"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerificationStep = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _react = require("react");
var _Localization = require("../../Localization");
var _defaultTranslations_simplifiedRegistrationBrandPartner = require("../../constants/defaultTranslations_simplified-registration-BrandPartner");
var _contexts = require("../../contexts");
var _interfaces = require("../../interfaces");
var _models = require("../../models");
var _api = require("../../models/api");
var _utils = require("../../utils");
var _BasicSkeleton = require("../BasicSkeleton");
var _Verification = require("../Verification");
var _StepsStyledComponents = require("./StepsStyledComponents");
var _VerificationChannelForm = require("./VerificationChannelForm");
var _VerificationLoading = require("./VerificationLoading");
var _jsxRuntime = require("react/jsx-runtime");
const RootContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  width: '100%',
  maxWidth: '500px',
  margin: '0 auto',
  marginTop: theme.spacing(4)
}));
const VerifyWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column'
}));
const WrapperContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  textAlign: 'center',
  marginTop: theme.spacing(7)
}));
const StyledSubTitle = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  marginBottom: theme.spacing(8)
}));
const VerificationIcon = (0, _mui.styled)(_icons.CheckCircle)(({
  theme
}) => ({
  fontSize: '60px',
  color: theme.palette.grey.A200
}));
const VerificationIconSuccess = (0, _mui.styled)(_icons.CheckCircleFilled)(({
  theme
}) => ({
  fontSize: '60px',
  color: theme.palette.primary.main
}));
const VerificationStep = props => {
  const {
    handleVerifySuccess
  } = props;
  const [isVerification, setIsVerification] = (0, _react.useState)(false);
  const [isPrimaryChannel, setIsPrimaryChannel] = (0, _react.useState)(false);
  const [isVerified, setIsVerified] = (0, _react.useState)(false);
  const [isSubmitting, setIsSubmitting] = (0, _react.useState)(false);
  const [resendDisabled, setResendDisabled] = (0, _react.useState)(false);
  const {
    data: contactMetadata
  } = (0, _api.useContactMetadata)();
  const {
    data: contactData
  } = (0, _api.useContactData)(isPrimaryChannel);
  const api = (0, _globalApiClientReact.useApiClient)();
  const {
    registrationId
  } = (0, _contexts.useConfiguration)();
  const {
    errorData
  } = (0, _contexts.useFormError)();
  const {
    customErrors,
    setErrorData
  } = errorData;
  const {
    notificationData
  } = (0, _contexts.useNotificationData)();
  const {
    setNotificationData
  } = notificationData;
  const {
    virtualPageAnalyticsData
  } = (0, _contexts.useVirtualPageAnalyticsData)();
  const {
    setPreviousStep
  } = virtualPageAnalyticsData;
  const isEmailVerification = contactMetadata?.email?.isAvailable;
  const contactTelephone = contactData?.contactTelephone ?? '';
  const contactEmail = contactData?.contactEmail ?? '';
  const showResendLink = contactMetadata?.isResendEnabled ?? false;
  const isLoginWithoutSocialNetwork = contactTelephone || contactEmail;
  const invalidCodeError = customErrors?.find(er => er.fieldName === 'ConfirmationCode');
  (0, _react.useEffect)(() => {
    (0, _utils.virtualPageEventDispatch)('ContactVerification', undefined, registrationId);
    setPreviousStep('ContactVerification');
    // eslint-disable-next-line react-hooks/exhaustive-deps -- virtual page event should be fired exacly once, no need to reevaluate
  }, []);
  const handleSubmitVerification = async code => {
    setIsSubmitting(true);
    try {
      const createConfirmResponse = await (0, _globalApiClientReact.createCustomerRegistrationContactDetailsConfirmation)(api, registrationId, {
        confirmationCode: code
      });
      const result = new _models.FetchResult(createConfirmResponse.status);
      if (result.isSuccess()) {
        setIsVerification(true);
        setTimeout(() => {
          setIsVerification(false);
          setIsVerified(true);
          setTimeout(() => {
            handleVerifySuccess();
            setErrorData([]);
          }, 300);
        }, 700);
      }
    } catch (error) {
      const errorResponse = error;
      if (errorResponse.response?.status === _globalApiClientReact.HttpStatusCodes.status400BadRequest) {
        const {
          Errors
        } = errorResponse.response.data;
        const submitErrors = Errors?.map(er => ({
          fieldName: er.PropertyName,
          errorCode: er.Code
        }));
        if (Array.isArray(submitErrors) && submitErrors.length > 0) {
          setErrorData(submitErrors);
        } else {
          setErrorData([]);
        }
      } else {
        setNotificationData({
          isOpen: true,
          message: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.cannotVerify,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.cannotVerify
          }),
          type: _interfaces.MessageType.error
        });
      }
    }
    setIsSubmitting(false);
  };
  const handleResendCode = async event => {
    event.preventDefault();
    setResendDisabled(true);
    setTimeout(() => {
      setResendDisabled(false);
    }, 60000);
    if (contactData) {
      try {
        const resendCodeResponse = await (0, _globalApiClientReact.updateCustomerRegistrationContactDetails)(api, registrationId, contactData);
        const result = new _models.FetchResult(resendCodeResponse.status);
        if (result.isSuccess()) {
          setNotificationData({
            isOpen: true,
            message: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
              id: _models.TranslationKey.successResend,
              defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.successResend
            }),
            type: undefined
          });
        }
      } catch (error) {
        setNotificationData({
          isOpen: true,
          message: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.cannotResend,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.cannotResend
          }),
          type: _interfaces.MessageType.error
        });
      }
    }
  };
  const content = isEmailVerification ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(WrapperContainer, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_StepsStyledComponents.StyledTitle, {
      variant: "h4",
      color: "textPrimary",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: _models.TranslationKey.EmailVerification_Header,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.EmailVerification_Header
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledSubTitle, {
      variant: "subtitle1",
      color: "textPrimary",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: _models.TranslationKey.EmailVerification_Text,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.EmailVerification_Text,
        values: {
          contactEmail
        }
      })
    })]
  }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(WrapperContainer, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_StepsStyledComponents.StyledTitle, {
      variant: "h4",
      color: "textPrimary",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: _models.TranslationKey.PhoneVerification_Header,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.PhoneVerification_Header
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledSubTitle, {
      variant: "subtitle1",
      color: "textPrimary",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: _models.TranslationKey.PhoneVerification_Text,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.PhoneVerification_Text,
        values: {
          contactTelephone
        }
      })
    })]
  });
  if (!contactData) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_BasicSkeleton.BasicSkeleton, {});
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(RootContainer, {
    children: [isVerification ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_VerificationLoading.VerificationLoading, {}) : null, isVerified ? /*#__PURE__*/(0, _jsxRuntime.jsx)(VerificationIconSuccess, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(VerificationIcon, {}), !isLoginWithoutSocialNetwork && !isPrimaryChannel ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_VerificationChannelForm.VerificationChannelForm, {
      handlePrimaryChannel: () => setIsPrimaryChannel(true)
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(VerifyWrapper, {
      children: [content, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Verification.Verify, {
        invalidCodeError: invalidCodeError,
        handleSubmitVerification: handleSubmitVerification,
        handleResendCode: handleResendCode,
        isSubmitting: isSubmitting,
        isResendDisabled: resendDisabled,
        showResendLink: showResendLink
      })]
    })]
  });
};
exports.VerificationStep = VerificationStep;